import React from 'react';
import {
  Platform,
  StyleProp,
  StyleSheet,
  View,
  ViewProps,
  ViewStyle,
} from 'react-native';

import { useColors } from '../../hooks';
import SafeAreaView from '../safe-area-view/safe-area-view';
import {
  extraSmallPaddingVerticalBox,
  mediumPaddingHorizontalBox,
} from '../view-style';

interface ActivityFooterProps {
  safeArea?: boolean;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

interface ActivityFooterSubcomponents {
  ButtonContainer: React.FC<ViewProps>;
}

const ActivityFooter: React.FC<ActivityFooterProps> &
  ActivityFooterSubcomponents = ({ children, style, safeArea = true }) => {
  const colors = useColors();
  return (
    <SafeAreaView
      style={[styles.bar, { backgroundColor: colors.grayLight }, style]}
      edges={safeArea ? ['bottom'] : []}
    >
      {children}
    </SafeAreaView>
  );
};

ActivityFooter.ButtonContainer = ({ children, style, ...props }) => (
  <View style={[styles.container, style]} {...props}>
    {children}
  </View>
);

const styles = StyleSheet.create({
  bar: {
    alignItems: 'center',
    ...mediumPaddingHorizontalBox,
    ...extraSmallPaddingVerticalBox,
  },
  container: {
    marginVertical: 6,
    width: Platform.select({
      web: 'auto',
      default: '100%',
    }),
  },
});

export default ActivityFooter;
